import { browserHistory } from 'react-router';
import {
  all,
  call,
  delay,
  fork,
  put,
  select,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects';

import * as DocType from '../../constants/constant_doc_types';

import * as api from '../../services/event/api_event';
import * as apiCommon from '../../services/apiCommon';
import * as common from '../sagasCommon';
import * as sectionTableActions from '../../components/common/form/SectionTable/actions';
import { getErrorMessage } from '../../utils';

export default function* (app) {
  try {
    yield all([
      fork(deleteEventSaga, app),
      fork(fetchEventForSaga, app),
      fork(fetchListEventSaga, app),
      fork(getEventLogs, app),
      fork(saveEventSaga, app),
    ]);
  } catch (e) {
    console.error('@saga_event: ', e.message || e.stack);
    throw e;
  }
}

function* fetchListEventSaga(app) {
  yield takeLatest(
    'FETCH_LIST_EVENT',
    callFetchListEvent,
    app,
  );
}

function* callFetchListEvent(app, action) {
  const { filters, silent } = action;
  yield common.showProgressListTable(silent);
  try {
    const dataParams = {
      filters,
      list_type: 'event',
    };

    const tableData = yield call(apiCommon.getDocs, app, dataParams);

    yield call(common.doneListTable, {
      rows: tableData.data,
      total_rows: tableData.total,
    });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}

function* deleteEvent(app, action) {
  try {
    const { id } = action;

    if (!id) return;

    yield put({ type: 'DELETE_RECORD_INPROGRESS' });

    const state = yield select();
    const { tenant, user } = state;
    const params = { tenant, user, id };
    const result = yield call(api.deleteEvent, app, params);

    yield put({
      type: 'DELETE_RECORD_DONE',
      payload: { id, docType: DocType.EVENT },
    });

    return result;
  } catch (error) {
    yield put({ type: 'DELETE_RECORD_ERROR', error });
  }
}

function* deleteEventSaga(app) {
  yield takeEvery(
    'DELETE_EVENT',
    callDeleteEvent,
    app,
  );
}

function* callDeleteEvent(app, action) {
  const result = yield deleteEvent(app, action);

  yield delay(2000);

  if (result) browserHistory.push('/admin/event');
}

function* fetchEventForSaga(app) {
  yield takeEvery(
    'FETCH_EVENT',
    callFetchEvent,
    app,
  );
}

function* callFetchEvent(app, action) {
  try {
    const { tenant, user } = yield select();
    const { id, silent } = action;

    if (!id) return;

    yield common.showProgressDataById(silent);

    const fetchParams = { tenant, user, id };
    const doc = yield call(
      api.fetchEvent,
      app,
      fetchParams
    );

    yield common.doneDataById(doc);
  } catch (error) {
    yield put({ type: 'FETCH_DATA_BY_ID_ERROR', error: error });
  }
}

function* saveEventSaga(app) {
  yield takeEvery('SAVE_EVENT', callSaveEvent, app);
}

function* callSaveEvent(app, action) {
  try {
    yield common.showProgressSaveRecord();
    const { tenant, user } = yield select();

    const result = yield call(api.saveEvent, app, {
      tenant,
      user,
      data: action.data,
    });

    const id = result && result.id;

    yield callFetchEvent(app, { id, silent: true });

    browserHistory.push(`/admin/event/edit/${id}`);

    yield common.doneSaveRecord(result, 'Event was saved');
  } catch (error) {
    yield common.showErrorSaveRecord(error);
  }
}

export function* getEventLogs(app) {
  yield takeEvery('GET_EVENT_LOGS', callGetEventLogs, app);
}

function* callGetEventLogs(app, action) {
  const { key, payload } = action;
  const { filters } = payload;

  yield put(sectionTableActions.setSectionTableLoader(key, true));

  try {
    const {
      data,
      total,
      limit,
      skip,
    } = yield call(api.getEventLogs, app, filters);

    const meta = {
      total,
      limit,
      skip
    };

    yield put(sectionTableActions.setSectionTableData(key, { data, meta }));
  } catch (err) {
    yield put(sectionTableActions.setSectionTableError(key, true, getErrorMessage(err)));
  }
}
